<app-nav></app-nav>
<div [ngSwitch]="routeVal">
  
    <div *ngSwitchCase="'1'">
        <app-verifier-dispute-list></app-verifier-dispute-list>
    </div>
    <div *ngSwitchCase="'2'">
        <app-admin-dispute-list></app-admin-dispute-list>
    </div>
    <div *ngSwitchCase="'3'">
        <app-superverifier-dashboard></app-superverifier-dashboard>
    </div>
    <div *ngSwitchCase="'4'">
        <app-document-master (event)="receiveVal($event)"></app-document-master>
    </div>
    <div *ngSwitchCase="'5'">
        <app-document-master-add></app-document-master-add>
    </div>
    <div *ngSwitchCase="'6'">
        <app-document-master-edit [childMessage]="parentMessage"></app-document-master-edit>
    </div>
    <div *ngSwitchCase="'7'">
        <app-stream-master></app-stream-master>
    </div>
    <div *ngSwitchCase="'8'">
        <app-stream-master-add></app-stream-master-add>
    </div>
    <div *ngSwitchCase="'9'">
        <app-stream-master-edit [childMessage]="streamData"></app-stream-master-edit>
    </div>
    <div *ngSwitchCase="'10'">
        <app-price-master (event)="receiveVal($event)"></app-price-master>
    </div>
    <div *ngSwitchCase="'11'">
        <app-price-master-add></app-price-master-add>
    </div>
    <div *ngSwitchCase="'12'">
        <app-price-master-edit [childMessage]="priceData"></app-price-master-edit>
    </div>
    <div *ngSwitchCase="'13'">
        <app-college-master></app-college-master>
    </div>
    <div *ngSwitchCase="'14'">
        <app-college-master-add></app-college-master-add>
    </div>
    <div *ngSwitchCase="'15'">
        <app-college-master-edit [childMessage]="collegeData"></app-college-master-edit>
    </div>
    <div *ngSwitchCase="'16'">
        <app-user-master></app-user-master>
    </div>
    <div *ngSwitchCase="'17'">
        <app-user-master-add></app-user-master-add>
    </div>
    <div *ngSwitchCase="'18'">
        <app-user-master-edit [childMessage]="userData"></app-user-master-edit>
    </div>
    <div *ngSwitchCase="'19'">
        <app-admin-dashboard></app-admin-dashboard>
    </div>
    <div *ngSwitchCase="'20'">
        <app-branch-master></app-branch-master>
    </div>
    <div *ngSwitchCase="'21'">
        <app-semester-master></app-semester-master>
    </div>
    <div *ngSwitchCase="'22'">
        <app-branch-master-add></app-branch-master-add>
    </div>
    <div *ngSwitchCase="'23'">
        <app-branch-master-edit [childMessage]="branchData"></app-branch-master-edit>
    </div>
    <div *ngSwitchCase="'24'">
        <app-semester-master-add></app-semester-master-add>
    </div>
    <div *ngSwitchCase="'25'">
        <app-semester-master-edit [childMessage]="semesterData"></app-semester-master-edit>
    </div>
    <!-- for University -->
    <div *ngSwitchCase="'26'">
        <app-university-verification-list></app-university-verification-list>
    </div>
  <!-- for Verifier -->
    <div *ngSwitchCase="'27'">
        <app-document-verification-list></app-document-verification-list>
    </div>
  <!-- for superVerifier -->
    <div *ngSwitchCase="'28'">
        <app-verifier-doc-list></app-verifier-doc-list>
    </div>
  <!-- for superAdmin -->
    <div *ngSwitchCase="'29'">
        <app-admin-dashboard ></app-admin-dashboard>
    </div>
  <!-- for associate -->
    <div *ngSwitchCase="'30'">
        <app-associate-add-record></app-associate-add-record>
    </div>
      <!-- for superAssociate -->
      <div *ngSwitchCase="'31'">
        <app-doc-upload-list></app-doc-upload-list>
    </div>

     <!-- for superAssociate Edit -->
    <div *ngSwitchCase="'32'">
        <app-edit-doc-upload-list [childMessage]="associateData"></app-edit-doc-upload-list>
    </div>

      <!-- for performance dashboard -->
      <div *ngSwitchCase="'33'">
        <app-superverifier-dashboard></app-superverifier-dashboard>
    </div>

       <!-- for only Search Document -->
       <div *ngSwitchCase="'34'">
        <app-uploaded-doc-list></app-uploaded-doc-list>
    </div>
    
    <div *ngSwitchCase="'35'">
        <app-passing-year-master></app-passing-year-master>
    </div>

    <div *ngSwitchCase="'36'">
        <app-passing-year-master-add></app-passing-year-master-add>
    </div>

    <div *ngSwitchCase="'37'">
        <app-passing-year-master-edit [childMessage]="yearOfPassingData"></app-passing-year-master-edit>
    </div>
    
    <div *ngSwitchCase="'38'">
        <app-record-entry></app-record-entry>
    </div>

    <div *ngSwitchCase="'39'">
        <app-mis-report></app-mis-report>
    </div>

    <div *ngSwitchCase="'40'">
        <app-university-dashboard></app-university-dashboard>
    </div>

    <div *ngSwitchCase="'41'">
        <app-verifier-rejected-request></app-verifier-rejected-request>
    </div>
</div>
<app-footer></app-footer>